import { BrowserRouter as Router, Routes, Route, Link, useLocation } from 'react-router-dom';
import Home from './pages/Home';
import Legal from './pages/LegalNotice';
import Privacy from './pages/PrivacyPolicy';
import Support from './pages/Support';
import Get from './pages/Get';
import SimpleConsent from "./components/SimpleConsent";

function AppShell() {
  const { pathname } = useLocation();
  const isGet = pathname === "/get";

  return (
    <>
      {!isGet && (
        <nav className="navbar">
          <div className="logo">CheerClip</div>
          <div className="nav-links">
            <Link to="/">Home</Link>
            <Link to="/support">Support</Link>
            <Link to="/legal">Legal</Link>
            <Link to="/privacy">Privacy</Link>
          </div>
        </nav>
      )}

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/get" element={<Get />} />
        <Route path="/support" element={<Support />} />
        <Route path="/legal" element={<Legal />} />
        <Route path="/privacy" element={<Privacy />} />
      </Routes>
      <SimpleConsent />
    </>
  );
}

function App() {
  return (
    <Router>
      <AppShell />
    </Router>
  );
}

export default App;
